import styled from '@emotion/styled';
import { Text, H2 } from 'ds/components/typography';

export const SectionTitle = styled(H2)`
  font-size: 29px;
  line-height: 36px;
  color: ${({ theme }) => theme.colors.neutrals.grey1};

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    font-size: 40px;
    line-height: 48px;
  `}
`;

export const SectionSubtitle = styled(Text)`
  font-size: 15px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.neutrals.grey1};

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    font-size: 17px;
  `}
`;
